import { Suspense } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { customeRoutes } from './lazy-load';
import Loader from '@shared/components/Loader';
import StatusMessage from '@shared/components/StatusMessage';
import Layout from './checkIsUserAuthenticated';
import UserManagement from '@/pages/SystemManagement/UserManagement';
import RoleManagementScreen from '@/pages/SystemManagement/RoleManagementScreen';
import ErrorBoundary from '@/components/common/ErrorBoundary';

export default function Navigation() {
  return (
    <div>
      <div>
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/login" element={<customeRoutes.LoginScreen />} />
              <Route path="/" element={<Layout />}>
                <Route path="/" element={<customeRoutes.Dashboard />} />
                <Route path="/management/" element={<customeRoutes.SystemManagementScreen />}>
                  <Route path="user-management" element={<UserManagement />} />
                  <Route path="role-management" element={<RoleManagementScreen />} />
                  <Route path="permissions-management" element={<UserManagement />} />
                  <Route path="my-profile" element={<UserManagement />} />
                </Route>
                <Route path="/user-permission/:id" element={<customeRoutes.UserPermissionsScreen />} />
                <Route path="/edit-role/:roleId" element={<customeRoutes.EditRole />} />
                <Route path="/create-role" element={<customeRoutes.EditRole />} />
                <Route path="/leg-list" element={<customeRoutes.LegListing />} />
                <Route path="/scenario-builder/:id/send-to-broker/:brokerName" element={<customeRoutes.SendToBroker />} />
                <Route path="/scenario-builder/:id" element={<customeRoutes.ScenarioBuilder />} />
                <Route path="/notes-panel" element={<customeRoutes.NotesPanel />} />
                <Route path="/split-groups" element={<customeRoutes.SplitGroups />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
}

function NotFound() {
  return (
    <StatusMessage
      title="Page not found"
      description="The page you’re looking for doesn’t exist or has moved."
      action={<Link to="/" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary text-decoration-none">Go to dashboard</Link>}
    />
  );
}
